import React from "react";
import Axios from "axios";
import axios from "services/axios";
import { Button, Card, message, Spin, Tooltip, Tag } from "antd";
import MUIDataTable from "mui-datatables";
import { MuiThemeProvider, createMuiTheme } from "@material-ui/core/styles";
import { Link } from "react-router-dom";
import momentTZ from "moment-timezone";
import _ from "lodash";

import ModalBranchDetail from "./Modal/ModalBranchDetail";
import { errorMessage } from "../../Utils";

let cancelToken;

class BranchList extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      branchDetail: {},
      branches: [],
      isLoading: true,
      confirmLoading: false,
      disableButton: true,
      page: 1,
      limit: 15,
      count: 0,
      search: "",
      sort: { name: "date", direction: "desc" },
    };
    this.visibleModalDetail = this.visibleModalDetail.bind(this);
  }

  componentDidMount() {
    this.setState({ isLoading: true });
    this.fetchBranch(this.state.page, this.state.limit);
  }

  orderBy(sort) {
    let key = "date";
    let value = "DESC";

    //Get Key
    if (sort.name === "Mobil Bekas") key = "carName";
    else if (sort.name === "Mobil Baru") key = "newCar";
    else if (sort.name === "Salesman") key = "salesman";
    else if (sort.name === "Tanggal Selesai") key = "date";

    //Get Value
    if (sort.direction === "asc") value = "ASC";
    else if (sort.direction === "desc") value = "DESC";

    return `${key}=${value}`;
  }

  async fetchBranch(page, limit) {
    const order = this.orderBy(this.state.sort);
    const query = `${order}&&page=${page}&&limit=${limit}&&search=${
      this.state.search || ""
    }`;
    if (cancelToken) {
      cancelToken.cancel("Operation canceled due to new request");
    }
    cancelToken = Axios.CancelToken.source();

    await axios
      .get(`admin-panel/branch?${query}`, {
        cancelToken: cancelToken.token,
      })
      .then(result => {
        this.setState({
          branches: result.data.branches,
          page: result.data.page,
          limit: result.data.limit,
          count: result.data.count,
          isLoading: false,
        });
      })
      .catch(err => {
        if (!Axios.isCancel(err)) {
          errorMessage(err.response || err);
          this.setState({ isLoading: false });
        }
      });
  }

  changePage(page, limit) {
    this.setState({ isLoading: true });
    this.fetchBranch(page, limit);
  }

  visibleModalDetail(branch) {
    this.setState({
      visibleModalDetail: !this.state.visibleModalDetail,
      branchDetail: branch,
    });
  }

  getMuiTheme = () =>
    createMuiTheme({
      typography: {
        useNextVariants: true,
      },
      overrides: {
        MUIDataTableBodyCell: {
          root: {
            "white-space": "nowrap",
            "&:nth-child(1)": {
              width: "8em",
              "min-width": "8em",
              "max-width": "10em",
              "word-break": "break-all",
            },
          },
        },
      },
    });

  render() {
    //Columns
    const columns = [
      {
        name: "Action",
        options: {
          sort: false,
        },
      },
      {
        name: "Branch",
        options: {
          sort: false,
        },
      },
      {
        name: "Branch Code",
        options: {
          sort: false,
        },
      },
      {
        name: "Branch Head",
        options: {
          sort: false,
        },
      },
      {
        name: "TNT",
        options: {
          sort: false,
        },
      },
      {
        name: "Mobbi Supervisor",
        options: {
          sort: false,
        },
      },
      {
        name: "Pricing Area",
        options: {
          sort: false,
        },
      },
      {
        name: "New Car Area",
        options: {
          sort: false,
        },
      },
      {
        name: "Branch Area",
        options: {
          sort: false,
        },
      },
      {
        name: "Business Area",
        options: {
          sort: false,
        },
      },
      {
        name: "Created At",
        options: {
          sort: false,
        },
      },
    ];

    //Data Branches
    const branches = this.state.branches.map((item, idx) => {
      return [
        <div>
          <Tooltip placement="bottom" title="Detail Branch">
            <Button
              icon="bars"
              style={{ marginRight: 10 }}
              onClick={() => this.visibleModalDetail(item)}
            />
          </Tooltip>
          <Tooltip placement="bottom" title="Update Branch">
            <Button
              type="primary"
              icon="edit"
              onClick={() =>
                this.props.history.push({
                  pathname: `/home/branch/update/${item.id}`,
                })
              }
            />
          </Tooltip>
        </div>,
        item.partnerName,
        item.code,
        item.BranchHead
          ? item.BranchHead.User
            ? item.BranchHead.User.name
            : ""
          : "",
        item.TNTProfile
          ? item.TNTProfile.User
            ? item.TNTProfile.User.name
            : ""
          : "",
        item.MobbiSPV ? item.MobbiSPV.name : "",
        item.AreaPricing ? item.AreaPricing.name : "",
        item.Area ? item.Area.name : "",
        item.AreaBranch ? item.AreaBranch.name : "",
        item.AreaBusiness ? item.AreaBusiness.area : "",
        momentTZ(item.updatedAt)
          .tz("Asia/Jakarta")
          .format("dddd, D MMMM YYYY HH:mm"),
      ];
    });

    //Options
    const options = {
      filter: false,
      responsive: "simple",
      fixedHeader: true,
      tableBodyHeight: "460px",
      print: false,
      selectableRows: "none",
      // resizableColumns: true,
      download: false,
      viewColumns: false,
      serverSide: true,
      rowsPerPage: this.state.limit,
      count: this.state.count,
      page: this.state.page - 1,
      searchText: this.state.search,
      onTableChange: (action, tableState) => {
        switch (action) {
          case "changePage":
            this.changePage(tableState.page + 1, tableState.rowsPerPage);
            break;
          case "changeRowsPerPage":
            this.changePage(1, tableState.rowsPerPage);
            break;
          case "search":
            this.setState({ search: tableState.searchText }, () =>
              this.changePage(1, tableState.rowsPerPage)
            );
            break;
          case "sort":
            this.setState({ sort: tableState.sortOrder }, () =>
              this.changePage(1, tableState.rowsPerPage)
            );
            break;
          default:
            break;
        }
      },
    };

    return (
      <Card
        title="List Branch"
        style={{
          marginTop: 35,
          background: "#fff",
          minHeight: 360,
        }}>
        <Spin size="large" spinning={this.state.isLoading} tip="Loading...">
          <Link
            to={{
              pathname: `/home/branch/create`,
            }}>
            <Button style={{ marginRight: 8 }}>Create Branch</Button>
          </Link>
          <MuiThemeProvider theme={this.getMuiTheme()}>
            <MUIDataTable
              title="List Branch"
              data={branches}
              columns={columns}
              options={options}
            />
          </MuiThemeProvider>

          <ModalBranchDetail
            data={this.state.branchDetail}
            visible={this.state.visibleModalDetail}
            visibleModal={this.visibleModalDetail}
          />
        </Spin>
      </Card>
    );
  }
}

export default BranchList;



// WEBPACK FOOTER //
// src/components/Dashboard/Branch/BranchList.js